import React, { useEffect } from "react"
import {
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
import { useState } from "react"
import { SaveButton } from "components/Buttons"
import Select from "react-select"
import {
  ASSIGN_ACOUNT_TYPES,
  CORPORATE_TYPE,
  BUSINESS_UNIT_TYPE,
} from "constants/people"
import {
  createAdminUser,
  deleteAdminUser,
  updateAdminUser,
} from "store/actions"
import { connect } from "react-redux"

const AdminInfo = ({
  businessUnits,
  roles,
  profile,
  deleteAdminUser,
  vendorId,
  createAdminUser,
  updateAdminUser,
}) => {
  const [accType, setAccType] = useState(null)
  const [assignedBU, setAssignedBU] = useState(null)
  const [assignedRoles, setAssignedRoles] = useState(null)
  const [sendInvite, setSendInvite] = useState(false)

  useEffect(() => {
    if (!!profile) {
      switch (profile?.type) {
        case CORPORATE_TYPE:
          setAccType({ value: profile?.type, label: "Corporate" })
          setAssignedRoles(
            profile?.roles?.map(role => ({ value: role.id, label: role.name }))
          )
          break
        case BUSINESS_UNIT_TYPE:
          setAccType({ value: profile?.type, label: "Business Unit" })
          setAssignedRoles(
            profile?.roles?.map(role => ({ value: role.id, label: role.name }))
          )
          setAssignedBU({
            value: profile?.business_units[0]?.id,
            label: profile?.business_units[0]?.name,
          })
          break
        default:
          break
      }
    }
  }, [profile])

  const handleSave = () => {
    if (profile?.type == 0 && !!accType && !!assignedRoles) {
      // create admin user
      if (accType?.value == 1 && !assignedBU) return // error handling
      const { email, first_name, last_name, vendor_id, phone, ...rest } =
        profile
      createAdminUser({
        email,
        first_name,
        last_name,
        vendor_id,
        phone,
        type: accType?.value,
        roles: assignedRoles?.map(role => role?.value),
        ...(accType?.value == 1 ? { business_unit_id: assignedBU?.value } : {}),
        send_invite: sendInvite,
      })
    } else if (
      (profile?.type == 1 || profile?.type == 2) &&
      !accType &&
      !assignedRoles
    ) {
      // remove admin
      deleteAdminUser({
        type: profile?.type,
        vendorId: vendorId,
        userId: profile?.id,
        ...(profile?.type == 1 ? { buId: profile?.business_units[0]?.id } : {}),
      })
    } else if (
      (profile?.type == 1 || profile?.type == 2) &&
      !!accType &&
      !!assignedRoles
    ) {
      // update admin user
      if (accType?.value == 1 && !assignedBU) return // error handling
      const { email, first_name, last_name, vendor_id, phone, ...rest } =
        profile
      updateAdminUser({
        data: {
          email,
          first_name,
          last_name,
          vendor_id,
          phone,
          type: accType?.value,
          roles: assignedRoles?.map(role => role?.value),
          ...(accType?.value == 1
            ? { business_unit_id: assignedBU?.value }
            : {}),
          send_invite: sendInvite,
        },
        userId: profile?.id,
      })
    }
  }

  return (
    <Row>
      <Col>
        <h5 className="font-size-14 mb-0">
          <i className="mdi mdi-arrow-right text-primary"></i>
          Admin Information
        </h5>
        <Row className="form-group mt-3">
          <Col>
            <FormGroup>
              <Label for="accType">
                Assign Account Type{" "}
                <i className="fas fa-question-circle" id="accTypeTooltip" />
              </Label>
              <UncontrolledTooltip placement="top" target="accTypeTooltip">
                Assign this user to your Corporate Account or to an existing
                Business Unit.
              </UncontrolledTooltip>
              <Select
                inputId="accType"
                value={accType}
                placeholder="Select Account Type"
                options={ASSIGN_ACOUNT_TYPES}
                onChange={v => {
                  setAccType(v)
                  if (v?.value !== BUSINESS_UNIT_TYPE) {
                    setAssignedBU(null)
                  }
                  if (!v) {
                    setAssignedRoles(null)
                  }
                }}
                isClearable={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form-group mt-3">
          <Col>
            <FormGroup>
              <Label for="businessUnits">Assign to Business Unit</Label>
              <Select
                inputId="businessUnits"
                value={assignedBU}
                label="Assign to Business Unit"
                placeholder={
                  <span
                    className={
                      accType && accType?.value == 1 ? "text-danger" : ""
                    }
                  >
                    Select Business Unit
                  </span>
                }
                options={businessUnits.map(bUnit => ({
                  value: bUnit.id,
                  label: bUnit.name,
                }))}
                onChange={v => {
                  setAssignedBU(v)
                }}
                styles={{
                  control: styles => ({
                    ...styles,
                    borderColor:
                      accType && accType?.value == 1 && !assignedBU
                        ? "red"
                        : styles.borderColor,
                  }),
                }}
                isClearable={true}
                isDisabled={accType?.value !== BUSINESS_UNIT_TYPE}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form-group mt-3">
          <Col>
            <FormGroup>
              <Label for="roles">
                Assign Roles{" "}
                <i className="fas fa-question-circle" id="roleTooltip" />
              </Label>
              <UncontrolledTooltip placement="top" target="roleTooltip">
                Limit what this user can view by assigning a role
              </UncontrolledTooltip>
              <Select
                inputId="roles"
                value={assignedRoles}
                label="Assign Roles"
                placeholder={
                  <span
                    className={
                      accType && (accType?.value == 1 || accType?.value == 2)
                        ? "text-danger"
                        : ""
                    }
                  >
                    Select Roles
                  </span>
                }
                options={roles.map(role => ({
                  value: role.id,
                  label: role.name,
                }))}
                onChange={v => {
                  setAssignedRoles(v)
                }}
                styles={{
                  control: styles => ({
                    ...styles,
                    borderColor:
                      accType &&
                      (accType?.value == 1 || accType?.value == 2) &&
                      !assignedRoles
                        ? "red"
                        : styles.borderColor,
                  }),
                }}
                isClearable={true}
                isMulti={true}
                isDisabled={!accType?.value}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="form-group mt-3">
          <Col>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={sendInvite}
                  onChange={event => {
                    setSendInvite(event.target.checked)
                  }}
                  disabled={!accType?.value}
                />{" "}
                Send Invite
              </Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <label>Check to INVITE this Admin user to your dashboard.</label>
          </Col>
        </Row>

        <Row className="d-flex justify-content-end mt-1">
          <Col xs="auto">
            <SaveButton
              type="button"
              onClick={handleSave}
              disabled={profile?.type == 0 && !accType}
            >
              Save
            </SaveButton>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  deleteAdminUser: values => dispatch(deleteAdminUser(values)),
  createAdminUser: values => dispatch(createAdminUser(values)),
  updateAdminUser: values => dispatch(updateAdminUser(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AdminInfo)
